import type { FaireProductEntity } from "../../entity_types/product";

export const p_77ymxebysd: FaireProductEntity = {
  token: "p_77ymxebysd",
  type: "product",
  name: "tropical watercolor workbook",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/f63fad69683fcf993e343c14591927fa3963d549102dd0b2c4448c0488a39b26.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9f326cf7592bb40d2e80ea6e9b7d3e1e6ed5345b8f7758347fc8a7dc0ae42ad.jpeg",
    "https://cdn.faire.com/fastly/f2c4e7382d276b153cf373b7c8265c46e917bfc7aba9ef97d3bd75eccdb60837.jpeg",
    "https://cdn.faire.com/fastly/bbd3bb9fb71b9114fa74b2acb1b80131c5c06acc3851c2ffcbf976e8ae2cbdf0.jpeg",
    "https://cdn.faire.com/fastly/28e0829410c456a11d457721448ddd57ccbe93c617e794c2e1c14ec67b9d0c5f.jpeg",
    "https://cdn.faire.com/fastly/6af12d80bc7110de26c862a7a68adcd3730d981cf2462cf005a8baff7b1044fc.jpeg",
  ],
  priceDollars: 12,
  description:
    "Twelve tropical illustrations — a palm tree, hibiscus, sea turtle, flamingo, pineapple, surfboards, and more — each pre-outlined with step-by-step instructions. Paintings take about thirty minutes from start to finish, making it approachable for first-time painters and a favorite for gifting.\n\nA strong spring and summer seller. A favorite for spring break, summer vacations, and travel — pairs naturally with the paint set as a take-along gift. Performs well in coastal and resort-area boutiques.\n",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:11:11.405Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
